<template>
  <div
    class="folder-container border-round cursor-pointer"
    @click="openFolder"
  >
    <div class="folder-visual">
      <div class="folder-tab" />
      <div class="folder-body">
        <div
          v-if="folder.previews && folder.previews.length > 0"
          class="previews-container"
        >
          <img
            v-for="(preview, index) in folder.previews.slice(0, 3)"
            :key="index"
            :src="`https://media.shopimind.io/resize/index.php?src=${preview}&h=32&w=32`"
            :alt="`Preview ${index + 1}`"
            class="preview-thumb"
            :style="{ transform: `rotate(${(index - 1) * 8}deg)` }"
          />
        </div>
        <i
          v-else
          class="fas fa-folder-open folder-icon-inner"
        />
      </div>
    </div>
    <div class="folder-label">
      <span class="folder-name">{{ folder.name }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  PropType,
} from 'vue';

import { Folder } from '@/types';

import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'FolderItem',

  components: {},

  props: {
    folder: {
      type: Object as PropType<Folder>,
      required: true,
    },
  },

  emits: {
    'on-open-folder': Object,
  },

  setup(props, context) {
    const { t } = useI18n();

    const openFolder = () => {
      context.emit('on-open-folder', props.folder);
    };

    return {
      t,

      openFolder,
    };
  },
});
</script>

<style lang="scss" scoped>
.folder-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: var(--surface-100);

    .folder-body {
      background-color: #c8c8c8;
    }

    .folder-tab {
      background-color: #c8c8c8;
    }
  }
}

.folder-visual {
  position: relative;
  width: 80px;
  height: 64px;
  margin-bottom: 8px;
}

.folder-tab {
  position: absolute;
  top: 0;
  left: 0;
  width: 28px;
  height: 10px;
  background-color: #d5d5d5;
  border-radius: 4px 4px 0 0;
  transition: background-color 0.15s ease;
}

.folder-body {
  position: absolute;
  top: 8px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e0e0e0;
  border-radius: 0 6px 6px 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.15s ease;
  overflow: hidden;
}

.previews-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 4px;
}

.preview-thumb {
  width: 28px;
  height: 28px;
  object-fit: cover;
  border-radius: 3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.5);
  background-color: white;
}

.folder-icon-inner {
  font-size: 1.5rem;
  color: rgba(255, 255, 255, 0.7);
}

.folder-label {
  text-align: center;
  max-width: 100%;
}

.folder-name {
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--text-color);
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
}
</style>
